<template>
    <div class="content-page">
        <div class="content-nav">
            <el-breadcrumb class="breadcrumb" separator="/">
                <el-breadcrumb-item>促销活动</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="operation-nav">
                <router-link to="discount_add">
                    <el-button type="primary" icon="plus" size="small">添加新折扣</el-button>
                </router-link>
            </div>
        </div>
        <div class="content-main">
            
            <div class="form-table-box">
                <el-table :data="tableData" style="width: 100%" stripe>
                    
                    <!-- <el-table-column prop="goods_name" label="关联商品名称"></el-table-column> -->
                    <el-table-column prop="discount_name" label="促销名称"></el-table-column>
                    <el-table-column prop="goods_name" label="关联商品"></el-table-column>
                    <el-table-column prop="goods_price" label="商品原价(元)"></el-table-column>
                    <el-table-column prop="actual_price" label="商品折扣价(元)"></el-table-column>
                    <el-table-column prop="discount" label="折扣(折)"></el-table-column>

                    <el-table-column label="操作">
                        <template scope="scope">
                            <el-button size="small" @click="handleRowEdit(scope.$index, scope.row)">编辑</el-button>
                            <el-button size="small" plain type="danger" @click="handleRowDelete(scope.$index, scope.row)">删除
                            </el-button>
                        </template>
                    </el-table-column>

                </el-table>
            </div>
            <div class="page-box">
                <el-pagination @current-change="handlePageChange" :current-page="page" :page-size="size"
                               layout="total, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        data() {
            return {
                page: 0,
				size:10,
                total: 0,
                filterForm: {
                    name: ''
                },
                tableData: [],
                pIndex: 0,
                num: 0,
                activeClass: 0,
            }
        },
        methods: {
            
            handleClick(tab, event) {
                let pindex = tab._data.index;
				this.page = 1;
                this.getDiscountsList();
                this.pIndex = 1;
            },
            handlePageChange(val) {
                this.page = val;
                let nIndex = this.pIndex;
                if (nIndex == 0) {
                    this.getList();
                }
            },
            handleRowEdit(index, row) {
                this.$router.push({name: 'discount_add', query: {id: row._id,discountinfo:this.tableData[index]}});
            },
            handleRowDelete(index, row) {

                this.$confirm('确定要删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                let that = this;
                console.log("row._id is " + row._id);
                that.axios.post('discount/deleteDiscount', {id: row._id}).then((response) => {
                    if (response.data.code > 0) {
                        that.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        that.getDiscountsList();
                    }
                })
                }).catch(() => {
//                    this.$message({
//                        type: 'info',
//                        message: '已取消删除'
//                    });
                });
            },
            onSubmitFilter() {
                this.page = 1;
                this.getList();
            },
            clear(){
                this.axios.get('discount/getDiscountList', {
                    params: {
                        page: this.page,
						size: this.size
                    }
                }).then((response) => {
                    this.tableData = response.data.data
                    // this.page = response.data.data.currentPage
                    // this.total = response.data.data.count
                })
            },
            getDiscountsList() {
                this.axios.get('discount/getDiscountList', {
                    params: {
                        page: this.page,
						size: this.size
                    }
                }).then((response) => {

                    console.log("获取折扣列表。。。");
                    console.log(response.data);
                    this.tableData = response.data.data
                    //  this.page = response.data.data.currentPage
                    // this.total = response.data.data.count
                })
            }
        },
        components: {},
        mounted() {
            this.getDiscountsList();
        }
    }

</script>

<style scoped>
    .sort-width{
        width: 90px;
    }
    .right{
        float: right;
    }
    .form-inline {
        margin-top: 2px;
        height: 40px;
        margin-right: 20px;
    }

    .block {
        margin-bottom: 10px;
        height:42px;
        display: flex;
        align-items: center;
        justify-content:space-between;
    }

    .active {
        border-color: #ff4949;
        color: #ff4949;
    }

    .marginRight{
        margin-right: 20px;
    }
</style>
